export default {
  experimentId: '004_brasil_recommendations_experiment',
  featureId: '004_brasil_recommendations_experiment',
  viewClickAttributeId: 'wsoj',
};
